class RCLineItemDelete extends HTMLElement {

  connectedCallback() {
    this.addEventListener('click', this.deleteLineItem.bind(this));
  };

  disconnectedCallback() {
    this.removeEventListener('click', this.deleteLineItem.bind(this));
  };

  async getCartCountFromCart() {
    const res = await fetch('/cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    });
    const cart = await res.json();
    return cart.item_count;
  };

  async updateCount() {
    const cartCount = document.querySelector('[data-header-cart-count]');
    const count = await this.getCartCountFromCart();
    if(cartCount) cartCount.innerHTML = count === 0 ? '' : count;
    if(count == 0) cartCount?.classList.add('hidden'); 
  };

  deleteLineItem() {
    const lineItemId = this.dataset.lineItemId;
    if (!lineItemId) return;
    const cartItem = this.closest('[data-cart-item]');
    cartItem?.classList.add('disabled');
    this.setAttribute('aria-busy', 'true');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lineItemId, quantity: 0 })
    })
    .then((res) => {
      if (!res.ok) throw new Error('Cart change failed');
      return res.json();
    })
    .then(() => {
      cartItem?.remove();
      this.updateCount();
    })
    .catch(() => {
      cartItem?.classList.remove('disabled');
    })
    .finally(() => {
      this.setAttribute('aria-busy', 'false');
    });
  };

};

customElements.define('rc-line-item-delete', RCLineItemDelete);